import React from "react";
import { useAuth } from "../../context/Auth";
import styles from "./DeliveryCard.module.css";

const DeliveryCard = ({
  title,
  status,
  subtitle,
  subtitle1,

  imageUri,

  // ICONS
  viewIcon,
  editIcon,
  deleteIcon,

  // ACTIONS
  onView,
  onEdit,
  onDelete,

  // OPTIONAL
  onClick,
}) => {
  const { mode } = useAuth();

  return (
    <div
      className={
        mode
          ? `${styles.delivery_card} ${styles.delivery_card_dark}`
          : styles.delivery_card
      }
      onClick={onClick}
    >
      {/* ========================= */}
      {/* TOP */}
      {/* ========================= */}

      <div className={styles.delivery_card_top}>
        {/* IMAGE */}
        <div
          className={
            mode
              ? `${styles.delivery_card_img} ${styles.delivery_card_img_dark}`
              : styles.delivery_card_img
          }
        >
          {imageUri ? (
            <img
              src={`${process.env.REACT_APP_S3URL}${imageUri}`}
              alt={title}
            />
          ) : (
            <div
              className={
                mode
                  ? `${styles.delivery_card_first_text} ${styles.delivery_card_first_text_dark}`
                  : styles.delivery_card_first_text
              }
            >
              {title?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </div>

        {/* TEXT */}
        <div className={styles.delivery_card_text}>
          <div
            className={
              mode
                ? `${styles.delivery_card_title} ${styles.delivery_card_title_dark}`
                : styles.delivery_card_title
            }
          >
            <p>{title}</p>
          </div>
           <div
            className={
              mode
                ? `${styles.delivery_card_subtitle} ${styles.delivery_card_subtitle_dark}`
                : styles.delivery_card_subtitle
            }
          >
            <p>{subtitle}</p>
          </div>

          <div
            className={
              mode
                ? `${styles.delivery_card_subtitle} ${styles.delivery_card_subtitle_dark}`
                : styles.delivery_card_subtitle
            }
          >
            <p>{subtitle1}</p>
          </div>

          <div className={styles.delivery_card_status}>
            <p>{status}</p>
          </div>
        </div>
      </div>

      {/* ========================= */}
      {/* ICONS */}
      {/* ========================= */}

      <div className={styles.delivery_card_icons}>
        <div
          className={
            mode
              ? `${styles.delivery_icon_btn} ${styles.delivery_icon_btn_dark}`
              : styles.delivery_icon_btn
          }
          onClick={(e) => {
            e.stopPropagation();
            onView && onView();
          }}
        >
          {viewIcon}
        </div>

        <div
          className={
            mode
              ? `${styles.delivery_icon_btn} ${styles.delivery_icon_btn_dark}`
              : styles.delivery_icon_btn
          }
          onClick={(e) => {
            e.stopPropagation();
            onEdit && onEdit();
          }}
        >
          {editIcon}
        </div>

        <div
          className={
            mode
              ? `${styles.delivery_icon_btn} ${styles.delivery_icon_btn_dark}`
              : styles.delivery_icon_btn
          }
          onClick={(e) => {
            e.stopPropagation();
            onDelete && onDelete();
          }}
        >
          {deleteIcon}
        </div>
      </div>
    </div>
  );
};

export default DeliveryCard;
